var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputText',{ref:"inputField",attrs:{"type":_vm.type,"id":_vm.id,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"autofocus":_vm.autofocus,"min":_vm.min,"max":_vm.max},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }